
import { computed, defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'text'
    },
    maxlength: String,
    modelValue: {
      type: [String, Number],
      required: true
    },
    align: {
      type: String,
      default: 'center'
    },
    placeholder: String,
    isValid: {
      type: Boolean,
      default: true
    },
    msg: String,
    pattern: String,
    style: Object
  },

  emits: ['update:modelValue', 'focus', 'blur', 'input'],

  setup (props, { emit }) {
    const focus = ref(false)

    const inputValue = computed({
      get () {
        return props.modelValue
      },
      set (val) {
        emit('update:modelValue', val)
      }
    })

    function focusHandler (evt: FocusEvent) {
      focus.value = true

      emit('focus', evt)
    }

    function blurHandler (evt: FocusEvent) {
      focus.value = false

      emit('blur', evt)
    }

    function inputHandler (evt: InputEvent) {
      emit('input', evt)
      emit('update:modelValue', (evt.target as HTMLInputElement).value)
    }

    return {
      inputValue,
      focus,
      blurHandler,
      focusHandler,
      inputHandler
    }
  }
})
